const PrivacyPolicy = () => (
  <div className="max-w-3xl mx-auto px-6 py-12 text-gray-700">
    <h1 className="text-3xl font-bold mb-2 text-purple-700">Privacy Policy</h1>
    <p className="text-sm text-gray-400 mb-8">Last updated: May 2026</p>

    <section className="mb-8">
      <h2 className="text-xl font-semibold mb-3 text-gray-800">1. Who we are</h2>
      <p className="leading-relaxed">
        Stray AppTech Pte. Ltd. ("Stray Apps", "we", "us") operates <strong>stray-apps.com</strong>.
        This policy explains what data we collect, why, and how you can control it.
      </p>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-semibold mb-3 text-gray-800">2. Data we collect</h2>
      <ul className="list-disc pl-5 space-y-2 leading-relaxed">
        <li><strong>Account data</strong> — email address and display name when you register.</li>
        <li><strong>Usage data</strong> — pages visited, session duration, and feature interactions via Google Analytics (anonymised IP).</li>
        <li><strong>Cookies</strong> — see our <a href="/cookie-policy" className="text-purple-600 hover:underline">Cookie Policy</a>.</li>
      </ul>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-semibold mb-3 text-gray-800">3. How we use it</h2>
      <ul className="list-disc pl-5 space-y-2 leading-relaxed">
        <li>To provide and improve our services.</li>
        <li>To send transactional emails (password reset, verification).</li>
        <li>To analyse aggregate usage patterns.</li>
      </ul>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-semibold mb-3 text-gray-800">4. Data sharing</h2>
      <p className="leading-relaxed">
        We do not sell your data. We share it only with service providers necessary to operate the site
        (Firebase Auth, Google Analytics, Netlify hosting).
      </p>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-semibold mb-3 text-gray-800">5. Your rights</h2>
      <p className="leading-relaxed">
        You may request access, correction, or deletion of your personal data by emailing{' '}
        <a href="mailto:support@stray-apps.com" className="text-purple-600 hover:underline">support@stray-apps.com</a>.
      </p>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-semibold mb-3 text-gray-800">6. Contact</h2>
      <p className="leading-relaxed">
        Stray AppTech Pte. Ltd. · Singapore ·{' '}
        <a href="mailto:support@stray-apps.com" className="text-purple-600 hover:underline">support@stray-apps.com</a>
      </p>
    </section>
  </div>
);

export default PrivacyPolicy;
